import { styled } from "styled-components";

import { StyledModalText, UIButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { deleteCollection } from "domains/collection/actions";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

const StyledCollectionName = styled.div`
  background-color: ${({ theme }) => theme.colors.modalCardBackground};
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 10px;
`;

export const CollectionDeletionConfirmationModal = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { id, name } = useSelector(getModalParams) as ModalParams<"CollectionDeletionConfirmation">;
  const track = useTrack();
  const translate = useTranslate();

  const onClick = () => {
    dispatch(deleteCollection({ id }));
    track({ entityId: id, entityName: name, entityType: "Collection", name: "Delete Collection" });
    dispatch(deactivateModal());
    go("/create?mode=collection");
  };

  return (
    <>
      <ModalHeader title={translate("app.modal.delete_collection.title")} />
      <StyledModalText>{translate("app.modal.delete_collection.text")}</StyledModalText>
      <StyledCollectionName>{name}</StyledCollectionName>
      <UIButton error fullwidth onClick={onClick}>
        {translate("app.modal.reply.yes")}
      </UIButton>
    </>
  );
};
